/* ==========================================================================
   eg-lymph-ingredients — the mobile accordion of the herb cards.
   On desktop every card is open and the head is not interactive (CSS).
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.lfiInit === 'true') return;
    root.dataset.lfiInit = 'true';

    Array.prototype.forEach.call(root.querySelectorAll('[data-lfi-item]'), function (item) {
      var toggle = item.querySelector('[data-lfi-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
      });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lfi]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
